import { render } from "./collegeForm.vue?vue&type=template&id=20f8b0b5&scoped=true"
import script from "./collegeForm.vue?vue&type=script&lang=js"
export * from "./collegeForm.vue?vue&type=script&lang=js"

import "./collegeForm.vue?vue&type=style&index=0&id=20f8b0b5&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f8b0b5"]])

export default __exports__